import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromStore from '@app/store/reducers/user.reducers';

export const selectUserState = createFeatureSelector<fromStore.UserState>('users');

export const selectAllUsers = createSelector(selectUserState, fromStore.selectAll);

export const selectUser = (email: string) =>
  createSelector(selectAllUsers, (users) => users.find((user) => user.email === email));
